// @flow
import React, { Component } from 'react';
import PageTemplate from 'components/base/PageTemplate';
import MainContainer from 'containers/main/MainContainer';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import { type ContextRouter } from 'react-router-dom';
import { actionCreators as authActions } from 'store/modules/auth';
import { bindActionCreators, type Dispatch } from 'redux';
import { connect } from 'react-redux';
import queryString from 'query-string';

type Props = {
  AuthActions: typeof authActions,
} & ContextRouter;

class Home extends Component<Props> {
  constructor(props: Props) {
    super(props);
    const { AuthActions } = this.props;
    const query = queryString.parse(this.props.location.search);
    if (query.next) {
      AuthActions.setNextUrl(query.next);
    }
  }

  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <MainContainer />
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default connect(
  state => ({}),
  (dispatch: Dispatch<*>) => ({
    AuthActions: bindActionCreators(authActions, dispatch),
  }),
)(Home);



// WEBPACK FOOTER //
// ./src/pages/Home.js